export default __webpack_public_path__ + "static/media/Evie 9781843626367.08149db8.jpg";